import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
    fontSize: 30,
    lineHeight: 1.3,
    fontWeight: 'bold',
  },
  logoWrapper: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(6),
    textAlign: 'center',

    '& img': {
      marginLeft: theme.spacing(4),
      marginRight: theme.spacing(4),
      marginBottom: theme.spacing(4),
    },

    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',

      '& img': {
        marginBottom: 0,
      },
    },
  },
  mainArticles: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
  divider: {
    border: '1px solid #C2BEBE',
    margin: '20px 0px',
  },
  dividerTrusted: {
    border: '1px solid #C2BEBE',
    width: '85%',
  },
  divContent: {
    minHeight: 570,
    maxWidth: 360,
    justifyItems: 'center',
    alignContent: 'start',
    marginBottom: 70,
  },
  textDescription: {
    fontFamily: 'Lato',
    marginBottom: 15,
  },
  textInfo: {
    fontSize: 14,
    fontFamily: 'Lato',
    color: '#212121',
  },
  ctaLogo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    '& img': {
      height: 32,
    },
  },
  btnSeeMore: {
    backgroundColor: '#fff',
    border: '1px solid #9e9e9e',
    color: '#616161',
    padding: 10,
    borderRadius: 28,
    width: 130,
    textTransform: 'none',

    '&:hover': {
      backgroundColor: '#FAFAFA',
      border: '1px solid #7833FF',
      color: '#7833FF',
    },
  },
  publishedIn: {
    fontFamily: 'Lato',
    paddingRight: 227,
    paddingBottom: 8,
  },
  image: {
    width: '100%',

    '& hover': {
      cursor: 'pointer',
    },
  },
  textNumber: {
    color: '#757575',
    fontSize: 60,
    textAlign: 'center',
    height: 75,
  },
  textMore: {
    color: '#757575',
    fontSize: 20,
    fontFamily: 'Lato',
    textAlign: 'center',
  },
  textCreating: {
    fontSize: 30,
    color: '#fff',
    textAlign: 'center',
    fontFamily: 'Lato',
    lineHeight: 1.3,
  },
  btnCreating: {
    backgroundColor: '#fff',
    color: '#7833FF',
    padding: 10,
    borderRadius: 28,
    width: 170,
    textTransform: 'none',

    '&:hover': {
      backgroundColor: '#E5E5E5',
    },
  },
}));
